module.exports = __webpack_public_path__ + "img/7.a5d68a4f.png";